<div class="wrapper">
    <div class="cls-modal-block-header">
        <button
            class="mobile-filter-modal__close"
            (click)="attemptClose()"
            *ngIf="isMobile"
        >
            <img src="./assets/img/svg/arrow_back.svg" alt="Закрыть" />
        </button>
        <div class="title">Заявление для налоговой справки</div>
        <div
            class="btn-dialog-close"
            (click)="attemptClose()"
            *ngIf="!isMobile"
        >
            <img src="./assets/img/svg/cross.svg" alt="close" />
        </div>
    </div>

    <div class="loader" *ngIf="loading || !loadingFrm">
        <loader type="page"></loader>
    </div>

    <div class="statement-body">
        <form
            class="cls-statement-form"
            [formGroup]="frmStatement"
            *ngIf="loadingFrm && !showFormOk"
            [ngClass]="{ loader: loading }"
        >
            <!-- Налогоплательщик -->
            <div class="taxpayer">
                <div class="form-group">
                    <div class="taxpayer__title">Налогоплательщик</div>
                    <input
                        type="text"
                        required
                        [readonly]="loading"
                        formControlName="nalog_fio"
                        class="form-statement-field col-50"
                        placeholder="ФИО *"
                        [ngClass]="{
                            'invalid-input':
                                frmStatement.get('nalog_fio')?.touched &&
                                frmStatement.get('nalog_fio')?.invalid
                        }"
                    />
                    <input
                        type="text"
                        inputmode="numeric"
                        required
                        [readonly]="loading"
                        (keydown.space)="$event.preventDefault()"
                        (input)="onInput($event, 'inn')"
                        formControlName="nalog_inn"
                        class="form-statement-field col-20"
                        placeholder="ИНН *"
                        [ngClass]="{
                            'invalid-input':
                                frmStatement.get('nalog_inn')?.touched &&
                                frmStatement.get('nalog_inn')?.invalid
                        }"
                    />
                    <div class="taxpayer_passport">
                        <div class="passport_left">
                            <div class="cls-block-header-stat">
                                <span>Паспорт</span>
                            </div>
                            <div class="fields">
                                <input
                                    type="text"
                                    inputmode="numeric"
                                    required
                                    (input)="onInput($event, 'pasSeries')"
                                    maxlength="4"
                                    [readonly]="loading"
                                    formControlName="nalog_passport_series"
                                    class="form-statement-field col-15 digits"
                                    placeholder="Серия *"
                                    [ngClass]="{
                                        'invalid-input':
                                            frmStatement.get(
                                                'nalog_passport_series'
                                            )?.touched &&
                                            frmStatement.get(
                                                'nalog_passport_series'
                                            )?.invalid
                                    }"
                                />
                                <input
                                    type="text"
                                    inputmode="numeric"
                                    required
                                    (input)="onInput($event, 'pasNumber')"
                                    maxlength="6"
                                    [readonly]="loading"
                                    formControlName="nalog_passport_number"
                                    class="form-statement-field col-15 digits"
                                    placeholder="Номер *"
                                    [ngClass]="{
                                        'invalid-input':
                                            frmStatement.get(
                                                'nalog_passport_number'
                                            )?.touched &&
                                            frmStatement.get(
                                                'nalog_passport_number'
                                            )?.invalid
                                    }"
                                />
                            </div>
                        </div>
                        <div class="passport_right">
                            <span class="date__title">
                                Дата выдачи<span class="required-start"
                                    >&nbsp;*</span
                                >
                            </span>
                            <input
                                matInput
                                type="date"
                                [max]="maxDate"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                (input)="validateDate($event)"
                                formControlName="nalog_passport_date"
                                class="form-statement-field col-20"
                                [ngClass]="{
                                    'invalid-input':
                                        frmStatement.get('nalog_passport_date')
                                            ?.touched &&
                                        frmStatement.get('nalog_passport_date')
                                            ?.invalid
                                }"
                            />
                        </div>
                    </div>
                </div>
                <div class="add-patient__button">
                    <label
                        for="taxpayerIsPatient"
                        class="custom-checkbox-label"
                    >
                        Налогоплательщик является пациентом
                    </label>
                    <span class="checkbox__wrapper">
                        <input
                            id="taxpayerIsPatient"
                            type="checkbox"
                            class="cls-ch-recovery"
                            formControlName="is_taxpayer_patient"
                            (change)="onTaxpayerPatientChange($event)"
                        />
                    </span>
                </div>
            </div>

            <div>
                <div
                    class="form-group patient-group"
                    *ngFor="
                        let patientCtrl of patientGroups;
                        let i = index;
                        trackBy: trackByIndex
                    "
                    [formGroup]="patientCtrl"
                >
                    <div class="patient__top" *ngIf="i > 0">
                        <div class="taxpayer__title">Пациент {{ i + 1 }}</div>
                        <div
                            class="btn-dialog-close__second"
                            (click)="delPatient(i)"
                        >
                            <img
                                src="./assets/img/svg/cross.svg"
                                alt="close"
                                style="height: 0.7rem; width: 0.7rem"
                            />
                        </div>
                    </div>
                    <div class="taxpayer__title" *ngIf="i === 0">Пациент</div>

                    <!-- Паиценты -->
                    <div class="taxpayer_passport">
                        <div class="passport_left">
                            <div
                                class="cls-block-header-stat taxpayer__title"
                                *ngIf="!isMobile"
                            >
                                <div class="taxpayer__fio">
                                    Фамилия Имя Отчество
                                </div>
                            </div>
                            <input
                                type="text"
                                required
                                [readonly]="loading"
                                formControlName="fio"
                                class="form-statement-field col-50"
                                placeholder="ФИО *"
                                [ngClass]="{
                                    'invalid-input':
                                        patientCtrl.get('fio')?.touched &&
                                        patientCtrl.get('fio')?.invalid
                                }"
                            />
                        </div>
                        <div class="passport_right">
                            <span class="birthday__title">
                                Дата рождения<span class="required-start"
                                    >&nbsp;*</span
                                >
                            </span>
                            <input
                                type="date"
                                required
                                [max]="maxDate"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                (input)="validateDate($event)"
                                formControlName="dr"
                                class="form-statement-field col-20"
                                [ngClass]="{
                                    'invalid-input':
                                        patientCtrl.get('dr')?.touched &&
                                        patientCtrl.get('dr')?.invalid
                                }"
                            />
                        </div>
                    </div>
                    <div class="taxpayer_passport">
                        <div class="col-50">
                            <div class="taxpayer_passport">
                                <div class="passport_left">
                                    <div class="cls-block-header-stat">
                                        <span>Паспорт</span>
                                    </div>
                                    <div class="fields">
                                        <input
                                            type="text"
                                            inputmode="numeric"
                                            required
                                            (input)="
                                                onInput($event, 'pasSeries')
                                            "
                                            maxlength="4"
                                            [readonly]="loading"
                                            formControlName="passportSeries"
                                            class="form-statement-field col-15 digits"
                                            placeholder="Серия *"
                                            [ngClass]="{
                                                'invalid-input':
                                                    patientCtrl.get(
                                                        'passportSeries'
                                                    )?.touched &&
                                                    patientCtrl.get(
                                                        'passportSeries'
                                                    )?.invalid
                                            }"
                                        />
                                        <input
                                            type="text"
                                            inputmode="numeric"
                                            required
                                            (input)="
                                                onInput($event, 'pasNumber')
                                            "
                                            maxlength="6"
                                            [readonly]="loading"
                                            formControlName="passportNumber"
                                            class="form-statement-field col-15 digits"
                                            placeholder="Номер *"
                                            [ngClass]="{
                                                'invalid-input':
                                                    patientCtrl.get(
                                                        'passportNumber'
                                                    )?.touched &&
                                                    patientCtrl.get(
                                                        'passportNumber'
                                                    )?.invalid
                                            }"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="passport_right">
                            <span class="date__title">
                                Дата выдачи<span class="required-start"
                                    >&nbsp;*</span
                                >
                            </span>
                            <input
                                type="date"
                                required
                                [max]="maxDate"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                (input)="validateDate($event)"
                                formControlName="passportDate"
                                class="form-statement-field col-20"
                                [ngClass]="{
                                    'invalid-input':
                                        patientCtrl.get('passportDate')
                                            ?.touched &&
                                        patientCtrl.get('passportDate')?.invalid
                                }"
                            />
                        </div>
                    </div>
                </div>

                <!-- Кнопка "Добавить пациента" -->
                <div
                    class="add-patient__button"
                    *ngIf="patientsFormArray.length < MAX_PATIENTS"
                >
                    <button
                        class="cls-add-patient"
                        type="button"
                        [disabled]="disableAddPatient()"
                        (click)="addPatient()"
                    >
                        + Дополнительный пациент
                    </button>
                </div>
            </div>

            <!-- Год -->
            <div class="cls-block-btn">
                <div class="year-title">
                    За какой год нужна справка?
                    <span class="required-start"> *</span>
                </div>
                <div class="cls-block-btn-year">
                    <button
                        class="form-statement-field years"
                        type="button"
                        *ngFor="let btnY of btnYearTxt; let i = index"
                        [disabled]="loading"
                        (click)="clicBtn(i)"
                        [class.active]="selectedIndexYear === i"
                    >
                        {{ btnY }}
                    </button>
                </div>
                <div class="add-patient__button">
                    <label
                        for="isRecoveryCheckbox"
                        class="custom-checkbox-label"
                    >
                        Требуется ли восстановление договора?
                    </label>
                    <span class="checkbox__wrapper">
                        <input
                            type="checkbox"
                            class="cls-ch-recovery"
                            formControlName="is_recovery"
                            id="isRecoveryCheckbox"
                        />
                    </span>
                </div>
            </div>

            <!-- Доверенное лицо -->
            <div class="taxpayer">
                <div class="cls-block-header-stat mb-05">
                    <div class="taxpayer__title">Доверенное лицо</div>
                </div>
                <div class="form-group agent">
                    <input
                        type="text"
                        required
                        [readonly]="loading"
                        formControlName="dov_fio"
                        class="form-statement-field col-50"
                        placeholder="ФИО *"
                        [ngClass]="{
                            'invalid-input':
                                frmStatement.get('dov_fio')?.touched &&
                                frmStatement.get('dov_fio')?.invalid
                        }"
                    />
                    <div class="email">
                        <input
                            type="email"
                            required
                            [readonly]="loading"
                            formControlName="email"
                            class="form-statement-field col-50"
                            placeholder="Email *"
                            [ngClass]="{
                                'invalid-input':
                                    frmStatement.get('email')?.touched &&
                                    frmStatement.get('email')?.invalid
                            }"
                        />
                    </div>
                    <div class="phone-number">
                        <span>+7 &nbsp;</span>
                        <input
                            type="text"
                            placeholder="(999) 999-99-99 *"
                            phoneMask
                            [preValue]="frmStatement.get('dov_phone')!.value"
                            required
                            maxlength="14"
                            formControlName="dov_phone"
                            class="form-statement-field col-20"
                            [ngClass]="{
                                'invalid-input':
                                    frmStatement.get('dov_phone')?.touched &&
                                    frmStatement.get('dov_phone')?.invalid
                            }"
                        />
                    </div>
                </div>
            </div>
            <button
                class="btn btn-lg w-100"
                [ngClass]="{
                    'cls-btn-send': isFormValid(),
                    'cls-btn-send-disable': !isFormValid()
                }"
                type="button"
                [disabled]="loading || !isFormValid()"
                (click)="save()"
            >
                Отправить
            </button>
        </form>

        <!-- Окно успешной отправки -->
        <div *ngIf="showFormOk" class="statement__ready">
            <img
                src="./assets/img/svg/statement_ready.svg"
                alt="statement_ready"
            />
            <h1 class="tab-success" style="font-size: 29px; margin: 20px 0">
                Ваше заявление отправлено на рассмотрение.
            </h1>
            <h3
                class="tab-success"
                style="font-size: 19px"
                *ngIf="INFO_HEADER_STATEMENT"
            >
                {{ INFO_HEADER_STATEMENT }}
            </h3>
            <p
                class="tab-success"
                style="font-size: 19px"
                *ngIf="INFO_BODY_STATEMENT"
            >
                {{ INFO_BODY_STATEMENT }}
            </p>
            <div class="statement__ready-return" (click)="navigateToHome()">
                Вернуться на главную страницу
            </div>
        </div>
    </div>
</div>

<!-- Подтверждение закрытия: срабатывает, если заполнено хоть одно поле  -->
<div class="confirmation-overlay" *ngIf="showConfirmation">
    <div class="confirmation-dialog">
        <div class="confirmation-header">
            <h3>Подтвердите закрытие</h3>
        </div>
        <div class="confirmation-body">
            <p>
                Вы уверены, что хотите закрыть форму?<br />
                Все несохранённые данные будут потеряны.
            </p>
        </div>
        <div class="confirmation-footer">
            <button class="btn btn-secondary" (click)="cancelClose()">
                Вернуться
            </button>
            <button class="btn btn-primary" (click)="confirmClose()">
                Да, закрыть
            </button>
        </div>
    </div>
</div>
